import { render, staticRenderFns } from "./SkipTo.vue?vue&type=template&id=3ad997af&scoped=true"
import script from "./SkipTo.vue?vue&type=script&lang=js"
export * from "./SkipTo.vue?vue&type=script&lang=js"
import style0 from "./SkipTo.vue?vue&type=style&index=0&id=3ad997af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad997af",
  null
  
)

export default component.exports